import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useSyncExternalStore } from 'react';
import { EMPTY_ENTRY, subscribeToCylindoStore, getCylindoEntry, requestCylindoFetch } from './utils';

// deferFetch: start Cylindo config request after window load + idle (not in render).
const useCylindoCache = (productId, isCylindoProduct, t0) => {
  const $ = _c(16);
  const deferFetch = t0 === undefined ? false : t0;
  let t1;
  let t2;
  if ($[0] !== deferFetch || $[1] !== isCylindoProduct || $[2] !== productId) {
    t1 = () => {
      if (!deferFetch || !productId || !isCylindoProduct) {
        return;
      }
      let cancelled = false;
      let cancelScheduled = _temp;
      const runFetch = () => {
        if (!cancelled) {
          requestCylindoFetch(productId);
        }
      };
      const afterLoad = () => {
        if (cancelled) {
          return;
        }
        if (typeof window.requestIdleCallback === "function") {
          const id = window.requestIdleCallback(runFetch, {
            timeout: 5000
          });
          cancelScheduled = () => {
            if (typeof window.cancelIdleCallback === "function") {
              window.cancelIdleCallback(id);
            }
          };
        } else {
          const id_0 = window.setTimeout(runFetch, 2000);
          cancelScheduled = () => clearTimeout(id_0);
        }
      };
      if (typeof document !== "undefined" && document.readyState === "complete") {
        afterLoad();
      } else {
        if (typeof window !== "undefined") {
          window.addEventListener("load", afterLoad);
        }
      }
      return () => {
        cancelled = true;
        if (typeof window !== "undefined") {
          window.removeEventListener("load", afterLoad);
        }
        cancelScheduled();
      };
    };
    t2 = [deferFetch, productId, isCylindoProduct];
    $[0] = deferFetch;
    $[1] = isCylindoProduct;
    $[2] = productId;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[5] !== deferFetch || $[6] !== isCylindoProduct || $[7] !== productId) {
    t3 = () => {
      if (!deferFetch && productId && isCylindoProduct) {
        requestCylindoFetch(productId);
      }
    };
    t4 = [deferFetch, productId, isCylindoProduct];
    $[5] = deferFetch;
    $[6] = isCylindoProduct;
    $[7] = productId;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  useEffect(t3, t4);
  let t5;
  if ($[10] !== productId) {
    t5 = () => getCylindoEntry(productId);
    $[10] = productId;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const getSnapshot = t5;
  const getServerSnapshot = _temp2;
  const {
    config,
    version,
    loading
  } = useSyncExternalStore(subscribeToCylindoStore, getSnapshot, getServerSnapshot);
  let t6;
  if ($[12] !== config || $[13] !== loading || $[14] !== version) {
    t6 = {
      config,
      version,
      loading
    };
    $[12] = config;
    $[13] = loading;
    $[14] = version;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
export default useCylindoCache;
function _temp() {}
function _temp2() {
  return EMPTY_ENTRY;
}